var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2053_61691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3066 5.5L11 2.18914L7.69343 5.5L6.82 4.62543L11 0.440002L15.18 4.62543L14.3066 5.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.34 1.09998H11.66V14.52H10.34V1.09998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2615 22H4.73846C3.674 22 2.86 21.1778 2.86 20.1025V8.71751C2.86 7.64226 3.674 6.82001 4.73846 6.82001H9.12154V8.08501H4.73846C4.36277 8.08501 4.11231 8.33801 4.11231 8.71751V20.1025C4.11231 20.482 4.36277 20.735 4.73846 20.735H17.2615C17.6372 20.735 17.8877 20.482 17.8877 20.1025V8.71751C17.8877 8.33801 17.6372 8.08501 17.2615 8.08501H12.8785V6.82001H17.2615C18.326 6.82001 19.14 7.64226 19.14 8.71751V20.1025C19.14 21.1778 18.326 22 17.2615 22Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2053_61691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.52d6aa750d54e019cb10886b105e00f0.svg";
export { ForwardRef as ReactComponent };